import formDeviceEdit from './formDeviceEdit';
import formDeviceConfigsUsage from './formDeviceConfigsUsage';

export default {
  title: 'Device',
  attributeName: 'device',
  getURL: 'devices',
  createURL: 'devices',
  updateURL: 'devices',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formDeviceEdit, formDeviceConfigsUsage],
  noArea: true,
  goBack: true,
  idUpdate: true
};
